import { Component, OnInit, ViewChild, ElementRef, OnDestroy, inject, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { AuthService, BUYER_ROLE, BUYER_STATUS } from '../../../shared';
import { SearchModalComponent } from '../_component/search-modal/search-modal.component';
import { BaseComponent } from '../../../core';
import { BaseUser } from '../../../shared/auth/dto/base-user';
import { takeWhile } from 'rxjs/operators';
import dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
import { Platform } from '@angular/cdk/platform';
import { HomeDto, NoticeBoard } from 'src/app/dto';
import { HomeService } from 'src/app/services';
import { UDirectService } from 'src/app/services/udirect.service';
// import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
declare global {
  interface Window {
    Calendly: any;
  }
}

enum HEADER {
  SIMPLE = 'simple',
  CLOSED = 'closed',
  OPENED = 'opened',
  // SEARCHED = 'searched',
  NONE = 'none',
}

enum FOOTER {
  COMMON = 'common',
  SINGLE = 'single',
  NONE = 'none',
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private platform = inject(Platform);
  uDirectService = inject(UDirectService);

  static UNAUTHORIZED_LAYOUT = {
    header: HEADER.SIMPLE,
    footer: FOOTER.SINGLE,
    gnb: false,
  };

  static COMMON_FOOTER_LAYOUT = {
    header: HEADER.NONE,
    footer: FOOTER.COMMON,
    gnb: false,
  };

  static CLOSED_LAYOUT = {
    header: HEADER.CLOSED,
    footer: FOOTER.NONE,
    gnb: false,
  };

  static CLOSED_WITH_GNB_LAYOUT = {
    header: HEADER.CLOSED,
    gnb: true,
    footer: FOOTER.COMMON,
  };

  static CLOSED_WITH_GNB_NONE_LAYOUT = {
    header: HEADER.CLOSED,
    gnb: true,
    footer: FOOTER.NONE,
  };

  static OPENED_WITH_GNB_LAYOUT = {
    header: HEADER.OPENED,
    gnb: true,
    footer: FOOTER.COMMON,
  };

  static COMMON_WITHOUT_GNB_LAYOUT = {
    header: HEADER.CLOSED,
    gnb: false,
    footer: FOOTER.COMMON,
  };

  user: BaseUser;
  isRouterUrlSignupSimplify: boolean;
  noticeBoards: NoticeBoard[] = [];
  isDisableNext = false; // true: 비활성화, false: 활성화
  isDisablePrev = true; // true: 비활성화, false: 활성화

  dlownloadapp: any;

  @ViewChild('searchModal', { static: false }) searchModal: SearchModalComponent;
  @ViewChild('FooterMore', { read: ElementRef, static: false }) footerMore: ElementRef;
  @ViewChild('target', { read: ElementRef, static: false }) target: ElementRef | undefined;

  header: HEADER = LayoutComponent.UNAUTHORIZED_LAYOUT.header;
  footer: FOOTER = LayoutComponent.UNAUTHORIZED_LAYOUT.footer;
  gnb = LayoutComponent.UNAUTHORIZED_LAYOUT.gnb;
  isNew = false;
  lang = this.LANGUAGES[0];
  isNotChrome = false;
  deviceOs = '';
  downBtnDeleay = 60; // minute 단위
  // visualNoticeConfig: SwiperConfigInterface = {};

  ngOnInit() {
    this.authService.emitOnLogin();
    this.isRouterUrlSignupSimplify = this.router.url.includes('simplify');
    if (!this.isRouterUrlSignupSimplify) {
      // window.Calendly.initBadgeWidget({
      //   url: 'https://calendly.com/umma_craver',
      //   text: 'schedule a meeting',
      //   color: '#f23da6',
      //   textColor: '#ffffff',
      //   branding: false,
      // });
    }
    let calendlyWidget: any = document.querySelector('.calendly-badge-widget');
    if (calendlyWidget) calendlyWidget.style.display = 'none';

    this.route.data.pipe(takeWhile(() => this.isAlive)).subscribe((data) => {
      this.user = this.authService.getUser();
      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.DORMANT) ||
          this.user.buyerStatus.includes(BUYER_STATUS.REACTIVATE))
      ) {
        this.router.navigate(['/signin/dormant']);
      }
      // if (this.user && !this.user.isCertified) {
      //   this.router.navigate(['/signin/mobile-otp']);
      // }
      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.WAITING) || this.user.buyerStatus.includes(BUYER_STATUS.REVIEWED))
      ) {
        this.router.navigate(['/signin/waiting']);
      }
      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.REFUSED) || this.user.buyerStatus.includes(BUYER_STATUS.REREQUEST))
      ) {
        this.router.navigate(['/my/account']);
      }
      if (this.user && this.user.userRoles.includes(BUYER_ROLE.BUYER_APPROVED) && data.layout) {
        // this.homeService.getNotice(this.i18n.language).subscribe((noticeBoard) => {
        //   this.noticeBoards = noticeBoard;
        //   this.visualNoticeConfig = this.makeSwiperConfig({
        //     autoplay: {
        //       delay: 10000,
        //       disableOnInteraction: false,
        //     },
        //     threshold: 25,
        //     slidesPerView: 1, // Number of slides per view
        //     // loop: true, // URL을 타지않음...오류 유발
        //     spaceBetween: 0,
        //     navigation: {
        //       nextEl: '.button-next-notice',
        //       prevEl: '.button-prev-notice',
        //     },
        //   });
        // });
        this.header = data.layout.header || this.header;
        this.footer = data.layout.footer || this.footer;
        this.gnb = data.layout.gnb || this.gnb;
        this.isNew = data.layout.new || this.isNew;
        this.uDirectService.checkUDirectAccess();
      }
    });

    this.LANGUAGES.forEach((lang) => {
      if (lang.locale === this.i18n.language) {
        this.lang = lang;
      }
    });

    this.unsupportedFunction();
  }

  ngAfterViewInit() {
    this.downloadDelay();
  }

  /**
   * 다운로드 버튼
   */
  downloadApp() {
    // 앱 다운로드 링크 연결
    let isAndroid = this.platform.ANDROID;
    let isIos = this.platform.IOS;
    window.location.assign(`https://app.umma.io/WA0Q6jUPeMb`);
  }

  downloadDelay(event?) {
    // 닫기버튼 누르면..1분뒤 다시 노출
    let expiredDate;
    let target: any = this.target?.nativeElement;

    if (event) {
      expiredDate = dayjs()
        .add(this.downBtnDeleay - 1, 'minute')
        .format('YYYY-MM-DD HH:mm:ss');
      localStorage.setItem('downloadapp', expiredDate);
      target.style.display = 'none';
    } else {
      if (!target || !target.style || !target.style.display) return;
      if (
        localStorage.getItem('downloadapp') &&
        dayjs(localStorage.getItem('downloadapp')).diff(dayjs(), 'minute') < 0
      ) {
        target.style.display = 'flex';
      } else if (!localStorage.getItem('downloadapp')) {
        target.style.display = 'flex';
      } else {
        target.style.display = 'none';
      }
    }
    setTimeout(() => {
      target.style.display = 'flex';
    }, this.downBtnDeleay * 60000);
  }

  scrollToBottom(target: HTMLElement): void {
    target.classList.toggle('active');
    setTimeout(() => {
      target.scrollIntoView();
    });
    // this.footerMore.nativeElement.classList.toggle('active');
    // this.footerMore.nativeElement.scrollIntoView();
    // const ele = document.getElementById('detail-footer');
    // ele.scrollIntoView();
  }

  unsupportedFunction() {
    if (this.deviceDetector.browser !== 'Chrome') {
      this.isNotChrome = true;
      this.deviceOs = this.deviceDetector.os;
    }
  }
  goPage(page, i) {
    if (this.noticeBoards[i].noticeCategory === 'APP') {
      window.open(this.noticeBoards[i].content.split('|')[1], '_blank');
    } else {
      this.router.navigate([page]);
    }
  }

  // 공지 화살표 css제어
  onChangeNoticeBanner(index) {
    this.isDisableNext = false;
    this.isDisablePrev = false;
    if (index === this.noticeBoards.length - 1) {
      this.isDisableNext = true;
    } else if (index === 0) {
      this.isDisablePrev = true;
    }
  }
}
